import { formatCarrierLogoCarrier } from "./CarrierLogo";

export const CARRIER_LABEL_COLORS: Record<string, string> = {
  UPS: "#351c15",
  FedEx: "#4d148c",
  DHL: "#D40511",
  Other: "text.secondary",
};

export const CARRIER_TRACK_URLS: Record<
  string,
  (trackingNumber: string) => string
> = {
  UPS: (n) => `https://www.ups.com/track?tracknum=${n}`,
  FedEx: (n) => `https://www.fedex.com/fedextrack/?tracknumbers=${n}`,
  DHL: (n) => `https://www.dhl.com/us-en/home/tracking/tracking-parcel.html?submit=1&tracking-id=${n}`,
  Other: (n) =>
    `https://www.google.com/search?q=${encodeURIComponent(n)}+tracking`,
};

// Build a carrier tracking URL from the carrier enum. The enum (e.g. "Ups",
// "Fedex", "Dhl") is normalized to the CARRIER_TRACK_URLS keys ("UPS", "FedEx",
// "DHL") so direct carrier links resolve instead of falling back to Google.
export function resolveCarrierTrackUrl(
  carrierEnum: string | null | undefined,
  trackingNumber: string | null | undefined,
): string {
  if (!trackingNumber) return "";
  const key = formatCarrierLogoCarrier(carrierEnum);
  const buildUrl = CARRIER_TRACK_URLS[key] ?? CARRIER_TRACK_URLS.Other;
  return buildUrl(trackingNumber);
}


